import { useQuery } from "@tanstack/react-query";

import { useLanguagesApi } from "../backend/index.ts";

export const useAvailableLanguages = () => {
  const { getAll, getQueryKey } = useLanguagesApi();
  const { data: availableLanguages } = useQuery({ queryKey: getQueryKey(), queryFn: getAll });

  // TODO: better error handling
  return availableLanguages ?? [];
};
